import IdentityNullState from './NoUploadsNullState';

export default IdentityNullState;
